export default {
	a: 1,
	b: 2,
	c: 4,
	d: 8,
} as const;
